<template>
<div>
  <div class="service_consultation show-pc">
    <div class="service_consultation_content">
      <div class="title">服务咨询</div>
      <div class="service_module">
        <div v-for="(item, index) in serviceList" :key="index" class="module_items">
          <div class="module_div">
            <div class="module_img cursor" @click.stop="toNewPage(item.key)">
              <hm-img type="images" :imgName="item.imgUrl" imgClass="module_img_style" />
            </div>
          </div>
          <div class="module_title">
            <span class="module_title_tip cursor" @click.stop="toNewPage(item.key)">{{item.title}}</span>
            <div class="module_title_skip" @click.stop="toNewPage(item.key)"><span class="tips">查看更多</span>
            <div class="module_title_img"><hm-img type="images" imgName="home_icon_02_zh" imgClass="module_icon_style" /></div>
            </div>
          </div>
          <div class="module_content">
            <div class="cursor" @click.stop="toNewPage(item.key)">{{item.content[0]}}</div>
            <div class="cursor" @click.stop="toNewPage(item.key)">{{item.content[1]}}</div>
            <div class="cursor" @click.stop="toNewPage(item.key)">{{item.content[2]}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="service_consultation_h5 show-h5">
    <div class="service_consultation_content_h5">
      <div class="title_h5">服务咨询
        <div class="title_h5_icon"><hm-img imgName="home_service_icon_06_h5_zh" imgClass="module_img_style"/></div>
      </div>
      <div class="service_module_h5">
        <div v-for="(item, index) in serviceList" :key="index" class="module_items_h5" :style="bgImage(item.key)">
          <div class="module_title_tip" @click.stop="toNewPage(item.key)">
            <div class="left_title">{{item.title}}</div>
            <div class="right_icon"><hm-img imgName="home_service_icon_07_h5_zh" imgClass="module_img_h5_style"/></div>
          </div>
          <ul class="module_content_ul">
            <li v-for="(liItem, index) in item.content" :key="index + 'li'" class="module_content_li cursor" @click.stop="toNewPage(item.key)">
              <div class="sphere"/>
              {{liItem}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
const serviceList = [
  {
    key: '1',
    title: '税务咨询',
    content: ['税务信息化建设', '税务筹划咨询', '转让定价咨询'],
    imgUrl: 'home_service_01.zh',
    imgH5Url: 'product_images_38_h5_zh'
  },
  {
    key: '2',
    title: '外包服务',
    content: ['代理记账报税', '税务鉴证服务', '代TP文档准备'],
    imgUrl: 'home_service_02.zh',
    imgH5Url: 'product_images_39_h5_zh'
  },
  {
    key: '3',
    title: '国际服务',
    content: ['跨境税务咨询', '关联交易咨询', '跨境服务对接'],
    imgUrl: 'home_service_03.zh',
    imgH5Url: 'product_images_37_h5_zh'
  }
]
export default {
  name: '',
  props: {},
  components: {},
  data () {
    return {
      serviceList,
      imgH5UrlParams: {
        '1': require('../../../assets/images/home_service_images_38_h5_zh.png'),
        '2': require('../../../assets/images/home_service_images_39_h5_zh.png'),
        '3': require('../../../assets/images/home_service_images_37_h5_zh.png')
      }
    }
  },
  filters: {},
  watch: {

  },
  computed: {

  },
  created () {

  },
  methods: {
    toNewPage (val) {
      console.log('%ctoNewPage', 'background-color: pink;', val)
      let target = {}
      switch (val) {
        case '1':
          target = {name: 'service', params: {type: 'product-tax-consulting'}}
          break
        case '2':
          target = {name: 'service', params: {type: 'product-outsourcing-services'}}
          break
        case '3':
          target = {name: 'service', params: {type: 'product-global-platform'}}
          break
        default:
          break
      }
      this.$router.push(target)
    },
    bgImage (key) {
      console.log('%c23232323', 'background-color: pink;', this.imgH5UrlParams[key])
      return {
        backgroundImage: 'url(' + this.imgH5UrlParams[key] + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center center'
      }
    }
  }
}
</script>

<style scoped lang='less'>
#hm-web {
  .service_consultation {
    background-color: #ffffff;
    height: 616PX;
    .service_consultation_content {
      width: 1200PX;
      margin: 0 auto;
      text-align: center;
    }
    .title {
      font-size: 36PX;
      color: #292F3A;
      line-height: 36PX;
      font-weight: 600;
      padding: 80PX 0 60PX;
    }
    .service_module {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .cursor {
        cursor: pointer;
      }
      .module_items {
        width: 384PX;
        height: 360PX;
        overflow: hidden;
        margin-right: 24PX;
        background: #FFFFFF;
        box-shadow: 0PX 2PX 4PX 0PX rgba(216,221,230,1);
        border-radius: 4PX;
        &:last-child {
          margin-right: 0;
        }
        .module_div {
          width: 100%;
          height: 220PX;
          overflow: hidden;
          .module_img {
            height: 220PX;
            transition: all 0.3s;
            &:hover {
              width: 100%;
              height: 220PX;
              transform: scale(1.1);
            }
          }
        }
        .module_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin:34PX 34PX 16PX;
          .module_title_tip {
            font-size: 20PX;
            color: #000000;
            font-weight: 600;
          }
          .module_title_skip {
            cursor: pointer;
            font-size: 14PX;
            color: #3E77FF;
            line-height: 36PX;
            font-weight: 400;
            display: flex;
            // align-items: center;
            .tips {
              margin-right: 8PX;
            }
            .module_title_img {
              width: 10PX;
            }
          }
        }
        .module_content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin:0 34PX;
          font-size: 14PX;
          color: #6E788B;
          line-height: 24PX;
          font-weight: 400;
          & div:hover {
            color: #3E77FF;
          }
        }
      }
    }
  }
  .service_consultation_h5 {
    width: 100%;
    background-color: #FFFFFF;
    .service_consultation_content_h5 {
      .title_h5 {
        font-family: PingFangSC-Medium;
        margin: 0 auto;
        font-size: 40px;
        color: #292F3A;
        letter-spacing: 2px;
        text-align: center;
        line-height: 60px;
        font-weight: 500;
        padding: 44px 0 60px;
        position: relative;
        .title_h5_icon {
          width: 32px;
          height: 32px;
          position: absolute;
          right: 37%;
          top: 16%;
          // transform: translate(50%, 70%);
        }
      }
      .service_module_h5 {
        padding: 0 40px 40px;
        .module_items_h5 {
          width: 100%;
          height: 240px;
          margin-bottom: 40px;
          padding-left: 56px;
          .module_title_tip {
            padding: 32px 0 16px 22px;
            display: flex;
            align-items: center;
            .left_title {
              font-size: 32px;
              color: #FFFFFF;
              letter-spacing: 0;
              line-height: 40px;
              font-weight: 500;
              margin-right: 32px;
            }
            .right_icon {
              width: 30px;
              height: auto;
              line-height: 100%;
            }
          }
          .module_content_ul {
            .module_content_li {
              display: flex;
              align-items: center;
              font-size: 24px;
              color: #FFFFFF;
              letter-spacing: 0;
              line-height: 40px;
              font-weight: 400;
                .sphere {
                width: 6px;
                height: 6px;
                background-color: #ffffff;
                border-radius: 50%;
                margin-right: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
#hm-web {
  .module_img_style {
    width: 100%;
    height: 100%;
  }
  .module_img_h5_style {
    width: 100%;
    height: auto;
  }
  .module_icon_style {
    width: 5PX;
    height: 9PX;
    transform: translateY(-20%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/serviceConsultation.vue